<!--
 * @Description: 身份证号位数转换
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-04-24 14:46:45
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<template>
    <div>
        <comp-title-dc back-url-name="acctManager" :back-url-query="{ activeIndex: '4-1' }">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/acctManager' }">账户管理</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/acctManager?activeIndex=4-1' }">
                    银行卡
                </el-breadcrumb-item>
                <el-breadcrumb-item>身份证号位数转换</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="bizcomp-id-number-tran">
            <div class="header-title">身份证号位数转换</div>
            <el-table :data="bankArr" class="tab-list-tit table-list">
                <el-table-column prop="bankcode" label="银行卡名称" align="center">
                    <template slot-scope="scope">
                        {{
                            $cache.getDict("110080", scope.row.bankcode).substr(-4, 4) +
                            $cache.getDict("110079", scope.row.paycenterid).substr(0, 4) +
                            "(" +
                            scope.row.depositcard.substr(-4, 4) +
                            ")"
                        }}
                    </template>
                </el-table-column>
                <el-table-column prop="depositcard" label="银行卡号码" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.depositcard }}
                    </template>
                </el-table-column>
                <el-table-column prop="certificateno" label="当前证件号" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.certificateno }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="transformcertificateno"
                    label="转换后证件号码"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ scope.row.transformcertificateno }}
                    </template>
                </el-table-column>
                <el-table-column prop="confirmedamount" label="操作" align="center">
                    <template slot-scope="scope">
                        <span class="tran-text" v-on:click="tranFn(scope.row)">转换</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog
            title="身份证号15-18位转换"
            :visible.sync="dialogShow"
            class="prop info-tips"
            width="580px"
            :before-close="closeDialog"
        >
            <div v-if="!resultSuc" class="dialog-contain">
                <div class="dialog-content">
                    <img src="../../assets/img/warn-expire.png" alt="" />
                    {{ "您确定将该卡对应的身份证号码(" + selectBank.certificateno + ")转换为" }}
                    <span class="color-e60012">
                        {{ "(" + selectBank.transformcertificateno + ")" }}
                    </span>
                    吗?
                    <div v-if="isPwdCheck" class="pwd-contain">
                        交易密码：
                        <el-input
                            v-model.trim="pwd"
                            type="password"
                            placeholder="请输入交易密码"
                            :maxlength="16"
                        />
                        <span
                            class="redemp-btn"
                            v-on:click.prevent="$router.push({ name: 'tradepwd' })"
                        >
                            <span class="like-a margin-l-10">忘记密码？</span>
                        </span>
                    </div>
                </div>
                <div class="btn-contain">
                    <button class="cancel-btn" v-on:click="closeDialog">取消</button>
                    <button class="confirm-btn" v-on:click="idTranFn">确定</button>
                </div>
            </div>
            <div v-else class="change-id-num-result">
                <div class="result-contain">
                    <div class="result-img-contain">
                        <img src="../../assets/img/success.png" alt="" />
                    </div>
                    <div class="result-text">转换成功!</div>
                </div>
                <div class="result-confirm-contain">
                    <button class="result-confirm" v-on:click="closeDialog">完成</button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import userApi from "@/api/user";

export default {
    name: "IdNumberTran",
    mixins: [mixin],
    data() {
        return {
            dialogShow: false,
            resultSuc: false,
            bankArr: [],
            selectBank: {},
            pwd: "",
            isPwdCheck: false
        };
    },
    mounted() {
        this.isPwdCheck = this.$cache.getPwdCheck("0A7");
        this.getBankInfo();
    },
    methods: {
        closeDialog() {
            this.getBankInfo();
            this.pwd = "";
            this.resultSuc = false;
            this.dialogShow = false;
        },
        async getBankInfo() {
            const reqRes = await userApi.getMyBankCards();
            if (reqRes.data.data) {
                // CMS配置的是否支持展示柜台增的卡
                this.bankArr = reqRes.data.data;
                this.bankArr = this.bankArr.filter((item) => {
                    return (
                        item.transformcertificateno != "" &&
                        (this.$util.showCounterCard() || item.banktype != "1")
                    );
                });
            }
        },
        tranFn(value) {
            this.selectBank = value;
            this.dialogShow = true;
        },
        async idTranFn() {
            const res = await userApi.combBankCardInfoUpdate({
                certificateno: this.selectBank.transformcertificateno,
                bankname: this.$cache.getDict("110080", this.selectBank.bankcode),
                paychannel: this.selectBank.paycenterid,
                tradepassword: this.$util.enc(this.pwd),
                transactionaccountid: this.selectBank.transactionaccountid
            });
            if (res.code == "0") {
                this.resultSuc = true;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-id-number-tran {
    width: 1200px;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
    margin-top: 13px;
    padding-bottom: 52px;
    .header-title {
        width: 1160px;
        padding: 17px 0 21px 0;
        margin-left: 20px;
        border-bottom: 1px solid #f1f1f1;
        font-size: 20px;
        font-weight: 500;
        color: #333333;
    }
    .table-list {
        width: 1160px;
        margin: auto;
        margin-top: 20px;
        border-left: 1px solid #f1f1f1;
        border-right: 1px solid #f1f1f1;
    }
    .tran-text {
        cursor: pointer;
        color: var(--color-primary);
    }
    :deep(.el-table) {
        th {
            background: #f9f9f9 !important;
        }
    }
}
.dialog-contain {
    padding: 28px 20px;
    .dialog-content {
        font-size: 20px;
        font-weight: 500;
    }
    .btn-contain {
        margin-top: 40px;
        .cancel-btn {
            margin-left: 50px;
            width: 180px;
            height: 42px;
            line-height: 42px;
            border-radius: 2px;
            background: #e4e4e4;
            font-size: 16px;
            font-weight: 500;
            text-align: center;
            color: #666666;
            cursor: pointer;
            border: none;
        }
        .confirm-btn {
            margin-left: 40px;
            width: 180px;
            height: 42px;
            line-height: 42px;
            border-radius: 2px;
            font-size: 16px;
            font-weight: 500;
            text-align: center;
            border: none;
            color: #ffffff;
            background: var(--color-primary);
            cursor: pointer;
        }
    }
    .pwd-contain {
        margin-top: 20px;
        display: flex;
        align-items: center;
        .el-input {
            width: 270px !important;
        }
        .margin-l-10 {
            margin-left: 10px;
        }
    }
    .color-e60012 {
        color: var(--color-primary);
    }
}
.change-id-num-result {
    text-align: center;
    .result-contain {
        width: 540px;
        margin: auto;
        margin-top: 40px;
        background: hsl(0, 0%, 98%);
        height: 242px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .result-text {
            font-size: 26px;
            margin-top: 24px;
            font-weight: 500;
            color: #333333;
        }
    }
    .result-confirm-contain {
        text-align: center;
        margin-top: 30px;
        .result-confirm {
            cursor: pointer;
            width: 180px;
            height: 42px;
            border-radius: 2px;
            background: var(--color-primary);
            border: 1px solid var(--color-primary);
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
        }
    }
}
</style>
